<template>
  <!--
    半身唤醒气泡（entryTipRender=custom，贴边后轻提示）
    轻量胶囊样式，复用 tipStyle 色板；箭头 class 供 TipContainer 定位
  -->
  <div class="entry-wake-tip" :style="tipCssVars">
    <p class="entry-wake-tip__text" v-html="messageHtml" />
    <!-- <div class="agent-entry-tip__arrow" aria-hidden="true" /> -->
  </div>
</template>

<script>
import agentTipStyleMixin from '@mixins/officialTopupNew/agentTipStyleMixin';

function escapeHtml(text) {
  return String(text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function formatHighlight(message, highlight) {
  const safeMsg = escapeHtml(message);
  const safeHi = escapeHtml(highlight);
  if (safeMsg.includes('{highlight}')) {
    return safeMsg.replace(/\{highlight\}/g, `<em>${safeHi}</em>`);
  }
  return safeHi ? `${safeMsg}<em>${safeHi}</em>` : safeMsg;
}

/**
 * EntryWakeTip
 * 半身态轻提示，无按钮；点击悬浮球由 SDK 处理唤醒
 */
export default {
  name: 'EntryWakeTip',
  mixins: [agentTipStyleMixin],
  props: {
    wakeMessage: {
      type: String,
      default: ''
    },
    wakeHighlight: {
      type: String,
      default: ''
    }
  },
  computed: {
    messageHtml() {
      return formatHighlight(this.wakeMessage, this.wakeHighlight);
    }
  }
};
</script>

<style scoped>
.entry-wake-tip {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 10px 16px;
  border-radius: 999px;
  background: var(--agent-tip-header-bg, #4c3d38);
  border: var(--agent-tip-border, 1px solid rgba(237, 206, 170, 0.45));
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.18);
  white-space: nowrap;
}

.entry-wake-tip__text {
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--agent-tip-name, #edceaa);
}

.entry-wake-tip__text >>> em {
  font-style: normal;
  color: var(--agent-tip-highlight, #edceaa);
  font-weight: 700;
}

/* 箭头底色跟随唤醒气泡；定位由 TipContainer 写入 */
.entry-wake-tip >>> .agent-entry-tip__arrow,
.entry-wake-tip /deep/ .agent-entry-tip__arrow {
  background: var(--agent-entry-tip-bg, var(--agent-tip-header-bg, #4c3d38));
}
</style>
